import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const InventoryStatisticsSkeleton = () => (
  <Styles.Container>
    <Skeleton variant="rounded" width="100%" height={72} />
    <Styles.ChartsContainer>
      {Array.from({ length: 6 }).map((_, index) => (
        <Skeleton key={index} variant="rounded" width="100%" height={120} />
      ))}
    </Styles.ChartsContainer>
  </Styles.Container>
)

export default InventoryStatisticsSkeleton
